var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.59 3.99625C17.21 3.61625 16.7 3.40625 16.17 3.40625H5C3.89 3.40625 3 4.30625 3 5.40625V19.4062C3 20.5063 3.9 21.4062 5 21.4062H19C20.1 21.4062 21 20.5063 21 19.4062V8.23625C21 7.70625 20.79 7.19625 20.41 6.82625L17.59 3.99625ZM12 19.4062C10.34 19.4062 9 18.0662 9 16.4062C9 14.7463 10.34 13.4062 12 13.4062C13.66 13.4062 15 14.7463 15 16.4062C15 18.0662 13.66 19.4062 12 19.4062ZM7 9.40625H13C14.1 9.40625 15 8.50625 15 7.40625C15 6.30625 14.1 5.40625 13 5.40625H7C5.9 5.40625 5 6.30625 5 7.40625C5 8.50625 5.9 9.40625 7 9.40625Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/Save_Icon.6e5536fbe90fd8bae89dfde9ea8e34ad.svg";
export { ForwardRef as ReactComponent };